import $ from 'jquery';
import showDisclaimer from '../js/modal-scrollable-validation';
const siteUtils = {};

siteUtils.FindTreatmentProvider = {
  fatpPath: `${location.origin}/provider`,
  _bindPreloadEvents: function () {
    const lib = this;

    // FATP SEARCH INPUT - SEARCH FATP ON CLICK and KEYPRESS
    $('.module-FATP_Searchform .FATP-search-btn').on('click', submitSearchParams);
    $('.module-FATP_Searchform').on('submit', submitSearchParams);
    $('.module-FATP_AdvanceSearchform .FATP-search-btn').on('click', submitSearchParams);
    $('.module-FATP_AdvanceSearchform').on('submit', submitSearchParams);
    $('.FATP-nearme-btn').on('click', submitNearMe);

    function submitSearchParams(e) {
      e.preventDefault();
      const $form = $(e.target).closest('.module-FATP_Searchform, .module-FATP_AdvanceSearchform');

      const isValidForm = lib._validateForm($form);
      if (isValidForm) {
        const url = lib._getUpdatedFatpPath($form);
        var params = {
          url: url,
       }

        // Legacy method. Pass value to CTA (DOM storage)
        $('.FATP-search-btn').attr('href', url);
        $('.module-FATP_Searchform').attr('action', url);
        $('.modal-disclaimer .modal__continue').attr('href', url);

        if (typeof (window.eventsManager.emit) != 'undefined') {
          window.eventsManager.emit("validFATPSearch", { "event": e, "params": params});
        }

        $form.find('.form-error').remove();
        showDisclaimer.showModal(e);
      }
    }

    function submitNearMe(e) {
      e.preventDefault();
      const $form = $(e.target).closest('.module-FATP_Searchform, .module-FATP_AdvanceSearchform');

      lib._getCurrentLocation()
        .then(function (position) {
          const url = `${lib.fatpPath}/results?lat=${position.latitude}&lng=${position.longitude}`;

          // Legacy method. Pass value to CTA (DOM storage)
          $('.FATP-search-btn').attr('href', url);
          $('.module-FATP_Searchform').attr('action', url);
          $('.modal-disclaimer .modal__continue').attr('href', url);

          $form.find('.form-error').remove();
          showDisclaimer.showModal(e);
        })
        .catch(console.error)
    }
  },
  _getCurrentLocation: async function () {
    // Determine if 'navigator.geolocation' exists
    if (navigator.geolocation) {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(
          function successCallback(position) {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          function failedCallback(err) {
            reject('Error: Failed to load current position. ' + err);
          },
          { timeout: 5000 }
        );
      })
    }
    else {
      reject('Error: "navigator.geolocation" not supported on your device/browser');
    }
  },
  _getUpdatedFatpPath: function ($form) {
    // Take FATP form submission and remap form fields to FATP processing path
    // Looking for: zipcode, distance, state
    const zipcode = $form.find('.FATP-search-input, #module-FATP-search-zipcode').val();
    const state = $form.find('#module-FATP-search-state').val();
    const distance = $form.find('#module-FATP-search-distance').val();

    const revisedQuery = [
      (zipcode ? 'zipcode=' + zipcode : ''),
      (state ? 'state=' + state : ''),
      (distance ? 'distance=' + distance : '')
    ]
      .filter(function (x) { return x != ''; })
      .join('&');

    return `${this.fatpPath}/results?${revisedQuery}`;
  },
  _validateForm: function ($form) {
    const $elmZip = $form.find('.FATP-search-input, #module-FATP-search-zipcode');
    const $elmState = $form.find('#module-FATP-search-state');

    const isValidZip = this._validateZIPCode($elmZip.val());
    const isValidState = ($elmState.length === 1 && $elmState.val() !== '') ? true : false;
    // RESET ERROR
    $form.find('.form-error').remove();

    // TODO: figure out the logic here
    // DETERMINE NEW ERROR
    if ($elmState.length === 1) {
      // console.log('CASE 1: YES STATE FIELD, YES ZIP FIELD')
      // console.log($elmZip, $elmZip.val(), $elmZip.val() === '')
      if ($elmZip.val() === '') {
        // console.log('CASE 1A: YES STATE FIELD, YES ZIP FIELD --- NO ZIP VALUE && CHECK STATE VALUE')
        if (!isValidState) {
          // TODO:  need to be removed or modified once we get response on how to handle this field
          $form.find('#module-FATP-search-state-label').append(`<p class="form-error flex-vertical-center">
            <svg class="svg--icon-warning">
              <use xlink:href="#icon-warning"></use>
            </svg>
            <span>Please select a state.</span>
            <i class="tool-tip-visual"></i>
          </p>`);
          $elmState.focus();
        }
        return isValidState;

      } else if ($elmZip.val() !== '') {
        // console.log('CASE 1B: YES STATE FIELD, YES ZIP FIELD --- CHECK ZIP VALUE')
        if (!isValidZip) {
          $form.find('#module-FATP-search-zipcode-label').append(`<p class="form-error flex-vertical-center">
            <svg class="svg--icon-warning">
              <use xlink:href="#icon-warning"></use>
            </svg>
            <span>A valid ZIP Code is required.</span>
            <i class="tool-tip-visual"></i>
          </p>`);
          $elmZip.focus();
        }
        return isValidZip;
      }
    } else {
      // CASE 2: NO STATE FIELD, YES ZIP FIELD ONLY,
      // console.log('CASE 2: NO STATE FIELD, YES ZIP FIELD ONLY')
      // console.log('CASE 2A: NO STATE FIELD, YES ZIP FIELD --- CHECK ZIP VALUE')
      if (!isValidZip) {
        // TODO:  need to be removed or modified once we get response on how to handle this field
        $form.find('label').append(`<p class="form-error flex-vertical-center">
            <svg class="svg--icon-warning">
              <use xlink:href="#icon-warning"></use>
            </svg>
            <span>A valid ZIP Code is required.</span>
            <i class="tool-tip-visual"></i>
          </p>`);
        $form.find('.FATP-search-input').attr("aria-invalid","true");
        $elmZip.focus();
      }
      else {
        $form.find('.FATP-search-input').attr("aria-invalid","false");
      }
      return isValidZip;
    }
  },
  _validateZIPCode: function (value) {
    return (/^\d{5}(-\d{4})?$/).test(value);
  },
  init: function () {
    this._bindPreloadEvents();
  }
};

const searchInit = function () {
  $(function () {
    siteUtils.FindTreatmentProvider.init();
  });
};

export default () => {
  searchInit();
};